export const error = {
    couldNotSave: "Could not save",
    ohNoSomethingWentWrong: "Oh no, something went wrong! :(",
    refreshAndTryAgain: "Refresh the page and try again.",
    goToLogin: "Go to Login",
};
